module.exports = __webpack_public_path__ + "static/media/od_9 copy.3ac87176.jpg";